import React from "react";
import Divider from "@mui/material/Divider";

interface propTypes {
  height?: string;
  background?: string;
  marginBottom?: string;
}

const CardDivider = (props: propTypes) => {
  let height = props.height;
  let background = props.background;
  let marginBottom = props.marginBottom;

  console.log("inside the divider");
  return (
    <div>
      <Divider
        style={{
          height: height,
          background: background,
          marginBottom: marginBottom,
        }}
      />
    </div>
  );
};

export default CardDivider;
